import { apiClient } from './sutras';
import { Meaning, Language } from '../types/meaning';

export const getMeanings = async (projectName: string, section: string, chapter: number, sutraNumber: number): Promise<Meaning[]> => {
    try {
        const meanings: Meaning[] = [];
        
        // Fetch meanings for all supported languages
        for (const lang of Object.values(Language)) {
            try {
                const response = await apiClient.get(
                    `sutras/${projectName}/${section}/${chapter}/${sutraNumber}/meaning?lang=${lang}`,
                    {
                        headers: {
                            'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
                        }
                    }
                );
                if (response.data) {
                    meanings.push({
                        ...response.data,
                        language: lang
                    });
                }
            } catch (error) {
                // Skip if meaning doesn't exist for this language
                console.debug(`No meaning found for language ${lang}`);
            }
        }
        
        return meanings;
    } catch (error) {
        console.error('Error fetching meanings:', error);
        return []; // Return empty array on error
    }
};

export const getMeaning = async (projectName: string, section: string, chapter: number, sutraNumber: number, language: Language): Promise<Meaning> => {
    const response = await apiClient.get(
        `sutras/${projectName}/${section}/${chapter}/${sutraNumber}/meaning?lang=${language}`,
        {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
            }
        }
    );
    return {
        ...response.data,
        language
    };
};

export const createMeaning = async (projectName: string, section: string, chapter: number, sutraNumber: number, meaning: Omit<Meaning, 'id'>): Promise<Meaning> => {
    const requestBody = { ...meaning, section };
    const response = await apiClient.post(
        `sutras/${projectName}/${section}/${chapter}/${sutraNumber}/meaning`,
        requestBody,
        {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
            }
        }
    );
    return response.data;
};

export const updateMeaning = async (projectName: string, section: string, chapter: number, sutraNumber: number, language: Language, meaning: Meaning): Promise<Meaning> => {
    const requestBody = { ...meaning, section };
    const response = await apiClient.put(
        `sutras/${projectName}/${section}/${chapter}/${sutraNumber}/meaning?lang=${language}`,
        requestBody,
        {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
            }
        }
    );
    return response.data;
};

export const deleteMeaning = async (projectName: string, section: string, chapter: number, sutraNumber: number, language: Language): Promise<void> => {
    await apiClient.delete(
        `sutras/${projectName}/${section}/${chapter}/${sutraNumber}/meaning?lang=${language}`,
        {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
            }
        }
    );
}; 